import { joinURL, hasProtocol } from 'ufo'
import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (src, { modifiers = {}, baseURL } = {}) => {
  const { width } = modifiers
  let thumb = ''

  // Map Nuxt's requested widths to your PocketBase thumbnail sizes
  if (width) {
    if (width <= 100) thumb = '?thumb=100x100'
    else if (width <= 250) thumb = '?thumb=250x250'
    else if (width <= 600) thumb = '?thumb=600x600'
    else if (width <= 1200) thumb = '?thumb=1200x1200'
  }

  const base = baseURL || 'https://backend.server.simonesmithphotography.com'

  // 🚀 BULLETPROOF FIX: If the src already has http:// or https://, don't prepend base
  if (hasProtocol(src)) {
    return {
      url: `${src}${thumb}`
    }
  }

  // Otherwise, it's a relative path (e.g., /api/files/...) so join them safely
  return {
    url: joinURL(base, `${src}${thumb}`)
  }
}
